import {
	GET_NOTIFICATION,
	CLEAR_NOTIFICATION,
	SEEN_NOTIFICATION,
	SUBSCRIPTION_NOTIFICATION,
	GET_CHECK_NOTI
} from "../ActionTypes"
import { checkDupArraynotification } from "../FunctionAction/function.project"
import { comparenoti } from "../containers/Function/Sort.functions"

const initialState = {
	notification: [],
	loading: false,
	LastEvaluatedKey: null,
	checkhave: null,
	notseen: 0
}
export default (state = initialState, { type, payload }) => {
	const { notification } = state
	switch (type) {
		case GET_NOTIFICATION + "_FULFILLED":
			let commentnoupdatecomment = payload.data.getNotification.data.filter(
				(item) => item.notification_title !== "updateComment"
			)
			let notseens = 0
			if (
				state.notification.length !== 0 &&
				commentnoupdatecomment !== 0 &&
				JSON.stringify(state.notification) !==
					JSON.stringify(commentnoupdatecomment)
			) {
				let filternotificationseen = state.notification.filter(
					(item) => item.seen === false
				)
				let filternotificationseenlenght = filternotificationseen.length
				let filtergetNotificationseen = commentnoupdatecomment.filter(
					(item) => item.seen === false
				)
				let filtergetNotificationseenlenght = filtergetNotificationseen.length
				notseens =
					filternotificationseenlenght + filtergetNotificationseenlenght
			} else {
				let filtergetNotificationseen = commentnoupdatecomment.filter(
					(item) => item.seen === false
				)
				notseens = filtergetNotificationseen.length
			}
			return {
				...state,
				notification: checkDupArraynotification(
					notification,
					commentnoupdatecomment
				),
				LastEvaluatedKey: payload.data.getNotification.next_token,
				notseen: notseens,
				loading: false
			}
		case GET_NOTIFICATION + "_PENDING":
			return { ...state, loading: true }
		case GET_NOTIFICATION + "_REJECTED":
			return { ...state, loading: false }
		case SUBSCRIPTION_NOTIFICATION:
			let subscriptiondata = [...notification]
			let notseenre = state.notseen
			if (JSON.stringify(state.checkhave) !== JSON.stringify(payload)) {
				subscriptiondata = subscriptiondata.concat(payload)
				notseenre += 1
			}
			return {
				...state,
				checkhave: payload,
				notification: subscriptiondata.sort(comparenoti),
				notseen: notseenre,
				loading: false
			}
		case SEEN_NOTIFICATION + "_FULFILLED":
			let notseenreseen = state.notseen
			for (let i = 0; i < notification.length; i++) {
				if (
					notification[i].notification_id ===
					payload.data.updateSeenNotification.notification_id
				) {
					notification[i].seen = payload.data.updateSeenNotification.seen
					notseenreseen -= 1
				}
			}
			return { ...state, notification, notseen: notseenreseen, loading: false }
		case SEEN_NOTIFICATION + "_PENDING":
			return { ...state, loading: true }
		case SEEN_NOTIFICATION + "_REJECTED":
			return { ...state, loading: false }
		case CLEAR_NOTIFICATION:
			return { ...state, notification: [] }
		case GET_CHECK_NOTI:
			return {
				...state,
				notseen: payload
			}
		default:
			return state
	}
}
